import type {IGeneralState} from "@/store/states/IGeneralState.interface";

const general = {
    namespaced: true,
    state: <IGeneralState>{
        locale: null,
        languages: [],
        currency: null,
        tax_charge: null,
        google_api_key: null,
    },
    mutations: {
        SET_LOCALE(state, payload) {
            state.locale = payload;
        },
        SET_LANGUAGES(state, payload) {
            state.languages = payload;
        },
        SET_CURRENCY(state, payload) {
            state.currency = payload;
        },
        SET_TAX_CHARGE(state, payload) {
            state.tax_charge = payload;
        },
        SET_GOOGLE_API_KEY(state, payload) {
            state.google_api_key = payload;
        },
    },
    actions: {
    },
    getters: {
    },
}

export default general;